import type { FillOperationParams } from 'ag-grid-enterprise';

/**
 * Double-clicking the fill handle makes AG Grid fill every row below the
 * selection in one go (same as in Excel). There is no grid option to turn that
 * off, and the gesture is both easy to hit by accident and destructive.
 *
 * Dragging the handle is unaffected: its `params.event` is the drag's `mouseup`.
 */
const isDoubleClickFill = (params: FillOperationParams) =>
  params.event.type === 'dblclick';

export const fillHandleOperations = {
  isDoubleClickFill,
};
